import { render, staticRenderFns } from "./form-input.vue?vue&type=template&id=0cff3e16&scoped=true&"
import script from "./form-input.vue?vue&type=script&lang=js&"
export * from "./form-input.vue?vue&type=script&lang=js&"
import style0 from "./form-input.vue?vue&type=style&index=0&id=0cff3e16&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cff3e16",
  null
  
)

export default component.exports